import type { Address } from "@/apis/gql/types";

/**
 * AI Assistant prompts are defined in the frontend rather than backend to allow for:
 * - Easier customization of prompts based on UI context and user interactions
 * - Dynamic prompt generation using runtime data/state
 * - Faster iterations on prompts without backend deployments
 */

export const supplierResearchPrompt = (
  supplierName: string,
  supplierAddress: Address = {
    addressId: "",
    addressLine1: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    postcode: "",
  },
) => {
  return {
    system: "",
    human: `${supplierName}, ${supplierAddress?.addressLine1}, ${supplierAddress?.city}`,
  };
};
